import type { Company, CompanyEmployee } from '../types/company.types';

// Mock data for development
const mockEmployeeCompanies: CompanyEmployee[] = [
  {
    employeeId: 'current-user',
    companyId: 'uk-ops',
    isDefault: true,
    accessLevel: 'full',
    assignedAt: new Date('2023-01-01'),
  },
  {
    employeeId: 'current-user',
    companyId: 'us-ops',
    isDefault: false,
    accessLevel: 'full',
    assignedAt: new Date('2023-06-01'),
  },
];

export const employeeCompanyService = {
  // Get companies for an employee
  async getEmployeeCompanies(employeeId: string): Promise<string[]> {
    // TODO: Replace with actual API call
    // return authFetch(`/api/employees/${employeeId}/companies`);
    const companyIds = mockEmployeeCompanies
      .filter((ec) => ec.employeeId === employeeId)
      .map((ec) => ec.companyId);
    return Promise.resolve(companyIds);
  },

  // Get employee's default company
  async getDefaultCompany(employeeId: string): Promise<string | null> {
    // TODO: Replace with actual API call
    // return authFetch(`/api/employees/${employeeId}/default-company`);
    const defaultCompany = mockEmployeeCompanies.find(
      (ec) => ec.employeeId === employeeId && ec.isDefault
    );
    return Promise.resolve(defaultCompany?.companyId || null);
  },

  // Set employee's default company
  async setDefaultCompany(employeeId: string, companyId: string): Promise<void> {
    // TODO: Replace with actual API call
    // return authFetch(`/api/employees/${employeeId}/default-company`, {
    //   method: 'PUT',
    //   body: JSON.stringify({ companyId })
    // });
    
    // Clear existing default
    mockEmployeeCompanies.forEach((ec) => {
      if (ec.employeeId === employeeId) {
        ec.isDefault = false;
      }
    });

    // Set new default
    const employeeCompany = mockEmployeeCompanies.find(
      (ec) => ec.employeeId === employeeId && ec.companyId === companyId
    );
    if (employeeCompany) {
      employeeCompany.isDefault = true;
    }

    return Promise.resolve();
  },

  // Update employee's company access
  async updateEmployeeCompanies(
    employeeId: string,
    companyIds: string[],
    defaultCompanyId: string
  ): Promise<void> {
    // TODO: Replace with actual API call
    // return authFetch(`/api/employees/${employeeId}/companies`, {
    //   method: 'PUT',
    //   body: JSON.stringify({ companyIds, defaultCompanyId })
    // });

    // Remove existing assignments
    const existingIndex = mockEmployeeCompanies.findIndex(
      (ec) => ec.employeeId === employeeId
    );
    if (existingIndex !== -1) {
      mockEmployeeCompanies.splice(existingIndex, mockEmployeeCompanies.length);
    }

    // Add new assignments
    companyIds.forEach((companyId) => {
      mockEmployeeCompanies.push({
        employeeId,
        companyId,
        isDefault: companyId === defaultCompanyId,
        accessLevel: 'full',
        assignedAt: new Date(),
      });
    });

    return Promise.resolve();
  },

  // Check if employee has access to company
  async hasAccessToCompany(employeeId: string, companyId: string): Promise<boolean> {
    // TODO: Replace with actual API call
    // return authFetch(`/api/employees/${employeeId}/companies/${companyId}/access`);
    const hasAccess = mockEmployeeCompanies.some(
      (ec) => ec.employeeId === employeeId && ec.companyId === companyId
    );
    return Promise.resolve(hasAccess);
  },
};
